import React from "react";
import StepForm from "../components/StepForm";

const Entitlement = () => {
  return (
    <>
      <section className="bg-primario min-h-screen flex flex-col items-center justify-center ">
        <div className="w-full md:max-w-4xl text-secundario pt-20 px-4 md:pt-10 md:px-0">
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-primaria font-bold mb-5">
            Entitlement Risk Scan
          </h1>
          <p className="text-base lg:text-lg">
            A high-level review of your project’s entitlement path to flag
            potential approval or cost risks early. This quick assessment helps
            you anticipate challenges without slowing your progress.
          </p>
        </div>
        <div className="w-full">
          <StepForm />
        </div>
      </section>
    </>
  );
};

export default Entitlement;
